
var retryChunkHandlers = __webpack_require__.f;
var retryAttempts = 2;
Object.keys(retryChunkHandlers).forEach(function(handlerKey) {
  var originalHandler = retryChunkHandlers[handlerKey];
  if (typeof originalHandler !== "function") return;
  retryChunkHandlers[handlerKey] = function(chunkId, promises) {
    var start = promises.length;
    originalHandler.call(retryChunkHandlers, chunkId, promises);
    for (var i = start; i < promises.length; i++) {
      promises[i] = retryFailedChunk(originalHandler, chunkId, promises[i], 0);
    }
  };
});
function bustChunkUrl(file, chunkId, targetId, attempt) {
  if (chunkId !== targetId || typeof file !== "string") return file;
  var join = file.indexOf("?") === -1 ? "?" : "&";
  return file + join + "wlj_retry=" + attempt;
}
function withBustedChunkUrl(chunkId, attempt, run) {
  var scriptName = __webpack_require__.u;
  var cssName = __webpack_require__.miniCssF;
  if (typeof scriptName === "function") {
    __webpack_require__.u = function(id) {
      return bustChunkUrl(scriptName(id), id, chunkId, attempt);
    };
  }
  if (typeof cssName === "function") {
    __webpack_require__.miniCssF = function(id) {
      return bustChunkUrl(cssName(id), id, chunkId, attempt);
    };
  }
  try {
    return run();
  } finally {
    if (typeof scriptName === "function") __webpack_require__.u = scriptName;
    if (typeof cssName === "function") __webpack_require__.miniCssF = cssName;
  }
}
function retryFailedChunk(originalHandler, chunkId, promise, attempt) {
  return promise.catch(function(error) {
    if (attempt >= retryAttempts) throw error;
    var nextAttempt = attempt + 1;
    return new Promise(function(resolve) {
      setTimeout(resolve, 400 * nextAttempt);
    }).then(function() {
      var again = [];
      withBustedChunkUrl(chunkId, nextAttempt, function() {
        originalHandler.call(retryChunkHandlers, chunkId, again);
      });
      var next = again.length ? again[again.length - 1] : Promise.resolve();
      return retryFailedChunk(originalHandler, chunkId, next, nextAttempt);
    });
  });
}
